import { render, staticRenderFns } from "./holidayActFemaleRank.vue?vue&type=template&id=71143721&scoped=true"
import script from "./holidayActFemaleRank.vue?vue&type=script&lang=js"
export * from "./holidayActFemaleRank.vue?vue&type=script&lang=js"
import style0 from "./holidayActFemaleRank.vue?vue&type=style&index=0&id=71143721&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71143721",
  null
  
)

export default component.exports